<p>market-details works!</p>
